import { render, staticRenderFns } from "./VacationRequest.vue?vue&type=template&id=25dbb042&scoped=true"
import script from "./VacationRequest.vue?vue&type=script&lang=js"
export * from "./VacationRequest.vue?vue&type=script&lang=js"
import style0 from "./VacationRequest.vue?vue&type=style&index=0&id=25dbb042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dbb042",
  null
  
)

export default component.exports